import { Header } from "@/components/header";
import Image from "next/image";

export default function ErrorPage() {
  return (
    <div className="flex flex-col flex-grow bg-muted xl:bg-white">
      <Header hideElements />
      <div className="flex lg:flex-row flex-col flex-1 lg:justify-around items-center gap-8 m-auto mb-20 px-8 pt-10 lg:pt-0 h-full container">
        <div className="flex flex-col gap-2 mt-12 lg:mt-0 max-w-100">
          <h2 className="font-semibold text-secondary text-4xl lg:text-6xl">
            Ooops!
          </h2>
          <h3 className="font-medium text-primary text-2xl lg:text-4xl">
            Esta página não pode ser encontrada!
          </h3>
        </div>
        <Image src="/error.svg" alt="Imagem de erro" width={500} height={500} />
      </div>
    </div>
  );
}
